import React, { createContext, FunctionComponent, useContext } from "react";
import { State } from "src/scenes/orgAdmin/formTemplates/types/messagesState";
import { Action, useFormTemplateMessagesProcessor } from "./processor";
import { ListMessageTemplatesFormType } from "./schemas";

type ContextValue = {
  state?: State;
  dispatch?: (action: Action) => void;
  formTemplateId?: uuid;
};

const ListMessageTemplateContext = createContext<ContextValue>({
  state: undefined,
  dispatch: undefined,
  formTemplateId: undefined,
});

type Props = {
  children: React.ReactNode;
  listMessagesInitialValues: ListMessageTemplatesFormType;
  formTemplateId: uuid;
};

export const ListMessageTemplateProvider: FunctionComponent<Props> = (
  props
) => {
  const { children, listMessagesInitialValues, formTemplateId } = props;
  const formTemplateMessagesState = useFormTemplateMessagesProcessor(
    { listMessages: listMessagesInitialValues },
    formTemplateId
  );

  return (
    <ListMessageTemplateContext.Provider
      value={{
        ...formTemplateMessagesState,
        formTemplateId,
      }}
    >
      {children}
    </ListMessageTemplateContext.Provider>
  );
};

export function useListMessagesTemplateContext() {
  const context = useContext<ContextValue>(ListMessageTemplateContext);

  if (context === undefined) {
    throw new Error(
      "useListMessagesTemplateContext must be used within a ListMessageTemplateContext"
    );
  }

  return context;
}

export function checkResetComplete(state: State | undefined) {
  return new Promise<void>((resolve) => {
    const checkState = () => {
      if (!state?.get("reset")) {
        resolve();
      } else {
        setTimeout(checkState, 10);
      }
    };
    checkState();
  });
}
